import React, {MouseEvent, useEffect, useState} from 'react';
import { Title } from '../../../../component/title/Title';
import Table from '../../../../component/table/Table.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import FormLabel from '../../../../component/input/FormLabel.component';
import { FormInput, FormSelect } from '../../../../component/input/InputStyle';
import  MenuItem  from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import GridComponent from '../../../../component/grid/GridComponent.component';
import ButtonComponent from '../../../../component/buttton/Button.component';
import { getTypeWalk, postParticularityStore, getParticularityStore, updateParticulatiryStore } from './ParticularityStoreService.component';
import FormFilter from './components/form/FormFilter.component'
import { Action, ACTION_EDIT } from '../../../../component/table/interfaces/TableInterface';
import { InterfaceStore, TypeVehicleInterface } from './interface/InterfaceStore';
import ModalUpdate from './components/modal/ModalUpdate.component';
import useModal from '../../../../hooks/useModal';
import { useManagement } from '../../../../context/Management';
import Loader from '../../../../component/Loader/LoaderComponent';
import { INITIAL_PAGINATION } from '../../../../component/table/component/pagination/utils/Pagination';
import { Pagination } from '../../../../component/table/interfaces/Pagination';
import { compare } from '../../../../utils/order/compare';
import { useSnackbar } from '../../../../context/Snackbar';

const ParticularityStorecomponent = () => {
    const {valueCd} = useManagement();
    const [open, addModal] = useModal();
    const { setSnackbar } = useSnackbar();
    const [valueStore, setValueStore] = useState('');
    const [valueTruck, setValueTruck] = useState('');
    const [valueTimeStart, setValueTimeStart] = useState('');
    const [valueTimeEnd, setValueTimeEnd] = useState('');
    const [labelTypeWalk, setLabelTypeWalk] = useState<TypeVehicleInterface[]>([]);
    const [buttonFilter, setButtonFilter] = useState(false);
    const [table, setTable] = useState<InterfaceStore[]>([])
    const [tableAux, setTableAux] = useState<InterfaceStore[]>([])
    const [idTruck, setIdTruck] = useState('');
    const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
    const [loading, setLoading] = useState(Boolean);
    const [tableValue, setTableValue] = useState<any>([]);

    const handleChange = ({target}: any) => {
        const {value, name} = target
        if (name === 'loja') {
            setValueStore(value);
        } else if (name === 'tipoVeiculo') {
            // console.log(value);
            const typeWalkId = labelTypeWalk.filter((item: TypeVehicleInterface) => {
                return value === item.tipoVeiculo;
            });
            setValueTruck(value);
            setIdTruck(typeWalkId[0].id);
        } else if (name === 'horarioInicio') {
            setValueTimeStart(value);
        } else if (name === 'horarioFim') {
            setValueTimeEnd(value);
        }
    }

    const cleanInputs = () => {
        setValueStore('');
        setValueTruck('');
        setValueTimeStart('');
        setValueTimeEnd('');
    }

    const handleClickSave = async () => {
        try {
            setLoading(true);
           const data = {
                cd: valueCd,
                loja: valueStore,
                tipoVeiculo: idTruck,
                horarioInicio: valueTimeStart,
                horarioFim: valueTimeEnd
              }
              // console.log('data', data)
            const res = await postParticularityStore(data);
            // console.log(res);
            if (res) {
                setSnackbar({type: 'success', msg: 'Cadastrado com sucesso.'});
                cleanInputs();
                getTableParticularityStore();
                setLoading(false);
            }
        } catch(error) {
            setLoading(false);
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível gravar.', type: 'error'})
            console.log(error);
        }
    }

    const getTableParticularityStore = async () => {
        try {
            setLoading(true);
            const res = await getParticularityStore(`${valueCd}`);
            // console.log('table',res.data)
            const tableParticularityStore = res.data.map((item: InterfaceStore) => {
                const data = {
                    ID: item.ID,
                    destino: item.destino,
                    tipoVeiculo: item.tipoVeiculo,
                    horarioInicio: item.horarioInicio,
                    horarioFim: item.horarioFim
                }
                return data
            })
            setTable(tableParticularityStore);
            // console.log('oi',table)
            setTableAux(tableParticularityStore);
            setLoading(false)
        } catch(error) {
            setLoading(false)
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível mostrar a tabela.', type: 'error'})
            console.log(error);
        }
    }

    const getLabelTypeWalk = async () => {
        try {
            const res = await getTypeWalk();
            setLabelTypeWalk(res.data);
            // console.log('opa', labelTypeWalk)
        } catch(error) {
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível mostrar os tipos de veículos.', type: 'error'})
            console.log(error);
        }

    }

    const pageSelect = (tableAux: InterfaceStore[]) => {
        if (pagination.page) {
            return tableAux.slice((pagination.page - 1) * 30, pagination.page * 30)
        }
        return tableAux;
    }

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPagination({ ...pagination, page: newPage + 1 });
    };

    const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
        const isAsc = pagination.sort === property && pagination.order === 1;
        setTableAux(tableAux.sort((a: any, b: any) => compare(a, b, property, isAsc ? -1 : 1)))
        setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
    };

    const handleSubmitSearch = (particularityStore: InterfaceStore) => {
        let tableParticularityStore: InterfaceStore[] = [...table].filter((el: InterfaceStore) => {
            let includesStore: boolean = !particularityStore.destino || String(el.destino).toLocaleLowerCase().includes(String(particularityStore.destino).toLocaleLowerCase());
            let includesTypeTruck: boolean = !particularityStore.tipoVeiculo || String(el.tipoVeiculo).toLocaleLowerCase().includes(String(particularityStore.tipoVeiculo).toLocaleLowerCase());
            // console.log('store', includesStore)
            return includesStore && includesTypeTruck;
        });
        const empty: boolean = !particularityStore.destino && !particularityStore.tipoVeiculo;
        // console.log('aquii', tableParticularityStore)
        setTableAux(empty ? [...table] : tableParticularityStore);
    };

    const handleClickAction = (action: Action, value: InterfaceStore, index: number) => {
        if (action === ACTION_EDIT) {
            addModal(!open);
            setTableValue(value)
        }
    }

    const closeModal = async (newStore: string, newTimeStart: string, newTimeEnd: string, newIdTruck: string, newIdModal: string) => {
        try {
            const data = {
                id: newIdModal,
                cd: valueCd,
                loja: newStore,
                tipoVeiculo: newIdTruck,
                horarioInicio: newTimeStart,
                horarioFim: newTimeEnd
            }
            const res = await updateParticulatiryStore(data)

            if (res) {
                setSnackbar({msg: 'Dados atualizados com sucesso.', type: 'success'})
                addModal(!open);
                getTableParticularityStore();
            }
        } catch(error) {
            setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível atualizar os dados', type: 'error'})
            console.log(error);
            addModal(!open);
        }
    }

    useEffect(() => {
        getLabelTypeWalk();
        getTableParticularityStore();
    }, [valueCd])

    return (
        <>
            <ButtonBackComponent to="/gestao-de-patio"/>
            <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Particularidades das Lojas</Title>
            <Grid item xs={12} sm={12} md={12} >
                <GridComponent justify='space-around' spacing={2}>
                    <FormLabel title="Loja" sm={12} md={5} lg={2}>
                        <FormInput type="text" value={valueStore} name="loja" onChange={handleChange}/>
                    </FormLabel>
                    <FormLabel title='Tipo de Veículo' sm={12} md={5} lg={2}>
                        <FormSelect value={valueTruck} name="tipoVeiculo" onChange={handleChange} displayEmpty={true} defaultValue={""}>
                            <MenuItem disabled value="">Selecione o tipo</MenuItem>
                            {labelTypeWalk.map((item:TypeVehicleInterface, index:number) => (
                                <MenuItem key={index} value={item.tipoVeiculo}>{item.tipoVeiculo}</MenuItem>
                            ))}
                        </FormSelect>
                    </FormLabel>
                    <FormLabel title="Horário Início" sm={12} md={5} lg={2}>
                        <FormInput type="time" value={valueTimeStart} name="horarioInicio" onChange={handleChange}/>
                    </FormLabel>
                    <FormLabel title="Horário Fim" sm={12} md={5} lg={2}>
                        <FormInput type="time" value={valueTimeEnd} name="horarioFim" onChange={handleChange}/>
                    </FormLabel>
                </GridComponent>
                <GridComponent justify='flex-end' spacing={0}>
                    <ButtonComponent title={'Gravar'} sizeFont='16px' size='medium' margin='29px 0px 29px 0px' onClick={handleClickSave} type='submit'/>
                </GridComponent>
                <GridComponent justify="flex-end" alignItems="center" margin='0px 0px 10px 0px'>
                    <ButtonComponent onClick={() => setButtonFilter(!buttonFilter)} title='filtro' size='medium' margin='16px 0px 0px 0px' />
                </GridComponent>
                <GridComponent>
                    {buttonFilter && <FormFilter handleSubmitForm={handleSubmitSearch} />}
                </GridComponent>
            </Grid>
           {open && <ModalUpdate open={!!open} handleClick={() => addModal(!open)} title={'Atualizar Dados'} onClickSubmit={closeModal} labelTruck={labelTypeWalk} data={tableValue}/>}
            {loading ? <Loader /> :
            <Table
            headCells={HEAD_CELL}
            data={pageSelect(tableAux)}
            page={pagination.page}
            size={tableAux.length}
            onChangePage={handleChangePage}
            order={pagination.order === 1 ? 'asc' : 'desc'}
            orderBy={pagination.sort}
            onRequestSort={handleRequestSort}
            noActionDelete
            noActionView
            handleClickAction={handleClickAction}/>}
        </>
    )
}

export default ParticularityStorecomponent;
